import React, { createRef, useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { ChipsContainer } from 'app/ComponentLibrary/Filter';
import { instanceOfISelection } from 'app/ComponentLibrary/Filter/CustomSelect';
import { selectFilters, selectGridState } from 'app/components/Common/Grid/GridStateManagement/GridState.selectors';
import { generateTaskChips, returnTaskFilterBody, TaskSearchFilterName } from './TaskFilterUtilitis';
import { gridStateActions } from 'app/components/Common/Grid/GridStateManagement/GridState.redux';
import { TaskCategory } from 'app/models/Tasks/Tasks';
import { Collapse, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SearchPageIcons } from 'app/ComponentLibrary/Filter/SearchPageIcons';
import { isEqual } from 'lodash';

const useStyles = makeStyles()({
  fillterCollapse: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export const TaskSearchChips = props => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { getValues, setValue } = useFormContext();
  const [chips, setChips] = useState({});
  const filterObject = useSelector(selectFilters);
  const { filterAttributes } = useSelector(selectGridState);
  const [checked, setChecked] = React.useState(false);
  const divRef = useRef<HTMLDivElement>(null);
  const hiddenArrowButton = createRef<HTMLButtonElement>();

  const handleChange = () => {
    setChecked(prev => !prev);
    props.setChipExpanded(prev => !prev);
  };

  const handleChipDelete = (field, chip) => {
    const chosenValue = getValues(field);

    if (chosenValue && chosenValue?.length > 0 && Array.isArray(chosenValue)) {
      const newValues = [...chosenValue];
      newValues.splice(
        newValues.findIndex(opt => isEqual(instanceOfISelection(chip) ? opt.value : opt, chip.value)),
        1,
      );
      setValue(field, newValues);
    } else {
      if (field === 'dueDate') {
        setValue(field, null);
      } else {
        setValue(field, []);
      }
    }

    const newFilters = returnTaskFilterBody(
      field,
      field === 'dueDate' ? chip.label : chip.value,
      filterAttributes?.selectedChipFilters,
      true,
    );
    // remove task names if rfo is not in categories
    if (
      field === TaskSearchFilterName.taskCategory &&
      newFilters.taskCategories?.length > 0 &&
      !newFilters.taskCategories?.find(f => f === TaskCategory.MISSINGRFOREQS) &&
      newFilters.taskName?.length > 0
    ) {
      newFilters.taskName = [];
      setValue(TaskSearchFilterName.taskName, []);
    }
    dispatch(gridStateActions.setSelectedChips(newFilters));
    props.onApplyFilter(getValues());
  };

  useEffect(() => {
    setChips(
      filterObject?.filters ? generateTaskChips(filterObject?.filters, false, filterObject?.selectedChipFilters) : {},
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterObject?.filters]);

  return (
    <>
      <Grid container>
        <Grid item xs={11}>
          <Collapse in={checked} collapsedSize={38}>
            <div ref={divRef}>
              <ChipsContainer
                isCollapse={!checked}
                chips={chips}
                onClick={() => {}}
                onDelete={(field, chip) => handleChipDelete(field, chip)}
              />
            </div>
            <button ref={hiddenArrowButton} style={{ display: 'none' }} type="submit" />
          </Collapse>
        </Grid>
        <Grid item xs={1} className={classes.fillterCollapse}>
          {(divRef?.current?.clientHeight ?? 0) > 38 && (
            <SearchPageIcons KeyboardArrowIcon onAdvancedChipsClick={() => handleChange()} checked={checked} />
          )}
        </Grid>
      </Grid>
    </>
  );
};
